module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "quote-form"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Info',
          to: {
            path: '/info'
          },
        },
        {
          text: !_vm.$route.query.id ? 'Tambah Info' : 'Ubah Info'
        } ],
      "divider": ">"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("\n        " + _vm._s(!_vm.$route.query.id ? "Tambah Info" : "Ubah Info") + "\n    ")]), _vm._v(" "), _c('v-card', {
    staticClass: "pa-4",
    attrs: {
      "plain": ""
    }
  }, [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    ID\n                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "id": "ambis_meter_info_id",
      "placeholder": "ID",
      "required": "",
      "outlined": ""
    },
    on: {
      "keypress": function($event) {
        /\d/.test(String.fromCharCode($event.keyCode)) ?
          true :
          $event.preventDefault()
      },
      "change": function($event) {
        _vm.form.id = _vm.form.id.replace(/\D/g, '')
      }
    },
    model: {
      value: (_vm.form.id),
      callback: function($$v) {
        _vm.$set(_vm.form, "id", $$v)
      },
      expression: "form.id"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Pertanyaan\n                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Pertanyaan",
      "outlined": ""
    },
    model: {
      value: (_vm.form.question),
      callback: function($$v) {
        _vm.$set(_vm.form, "question", $$v)
      },
      expression: "form.question"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Jawaban\n                ")]), _vm._v(" "), _c('v-textarea', {
    ref: "jawaban",
    attrs: {
      "counter": "",
      "placeholder": "Jawaban",
      "rules": _vm.rules,
      "outlined": ""
    },
    model: {
      value: (_vm.form.answer),
      callback: function($$v) {
        _vm.$set(_vm.form, "answer", $$v)
      },
      expression: "form.answer"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pa-4"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "px-6 py-2 white--text",
    attrs: {
      "depressed": "",
      "color": "blew"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("\n                Simpan")])], 1)], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b689704","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ambis_meter/components/InfoForm.vue
// module id = 981
// module chunks = 1